import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { ReviewsContextProvider } from "../Reviews/context/reviews.context";
import { ActionHandlerContextProvider } from "./context/actionHandler.context";
import { CartProductContextProvider } from "./context/cartProduct.context";
import { ProductConfigurationContextProvider } from "./context/productConfiguration.context";
import { StorePickerModalContextProvider } from "./context/storePickerModal.context";
import { useECommerceProduct } from "./hooks/useECommerceProduct.hook";

type ECommerceProviderProps = {};

export const ECommerceProviders = ({
    children
}: RequireChildrenFor<ECommerceProviderProps>) => {
    const { sku, brand, category } = useECommerceProduct();
    return (
        <ReviewsContextProvider
            sku={sku}
            brand={brand?.name}
            category={category}
        >
            <ProductConfigurationContextProvider>
                <CartProductContextProvider>
                    <StorePickerModalContextProvider>
                        <ActionHandlerContextProvider>
                            {children}
                        </ActionHandlerContextProvider>
                    </StorePickerModalContextProvider>
                </CartProductContextProvider>
            </ProductConfigurationContextProvider>
        </ReviewsContextProvider>
    );
};
